<template>
  <div>
    <money
      v-model="typed_volume"
      @input.native="setTyped_volume(typed_volume)"
      v-bind="money"
      class="investiment_input"
      :class="[
        $v.typed_volume.$error
          ? 'border-ontick-red-500'
          : 'border-ontick-steel-300 dark:border-ontick-steel-500',
      ]"
    />

    <transition name="fade">
      <div
        v-if="$v.typed_volume.$error"
        class="error transition-all duration-200"
      >
        <p v-if="!$v.typed_volume.required">
          ⛔ Volume não pode ser <strong> 0 </strong>
        </p>

        <p v-if="!$v.typed_volume.minValue && typed_volume > 0">
          ⛔Quantidade de contratos deve ser maior que
          <strong>{{ contract.max_scale_volume }}</strong>
        </p>

        <p v-if="!$v.typed_volume.maxValue">
          ⛔ Quantidade de contratos deve ser menor que
          <strong>{{ contract.max_absolute_volume }}</strong>
        </p>

        <p v-if="$v.typed_volume.mustBeCool == false">
          ⛔ Valor deve ser multiplo de {{ contract.volume_step }}
        </p>
      </div>
    </transition>
  </div>
</template>
<script>
import { Money } from "v-money";
import {
  required,
  minValue,
  maxValue,
  numeric,
  helpers,
} from "vuelidate/lib/validators";

const contains = (param) =>
  helpers.withParams({ type: "contains", value: param }, (value) => {
    if (value % param == 0) {
      return helpers.req(value) || true;
    } else {
      return !helpers.req(value) || false;
    }
  });
export default {
  components: {
    Money,
  },

  data() {
    return {
      money: {
        decimal: "",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
      typed_volume: 0,
    };
  },

  props: {
    contract: { type: Object },
    typed_volume_value: { type: Number },
  },

  validations() {
    return {
      typed_volume: {
        required,
        minValue: minValue(this.contract.max_scale_volume),
        maxValue: maxValue(this.contract.max_absolute_volume),
        numeric,
        mustBeCool: contains(this.contract.volume_step),
      },
    };
  },

  created() {
    this.typed_volume = this.contract.max_scale_volume;
  },

  methods: {
    setTyped_volume(value) {
      // if (value >= this.contract.max_scale_volume && value < this.contract.max_absolute_volume) {
      //   this.typed_volume = value;

      //   // alert("Alavancar !");
      // }
      this.$v.typed_volume.$touch();
      this.$emit("updateValue", this.typed_volume);
      this.$emit("inputValidate", this.$v.$invalid);
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
  overflow: hidden;
  position: absolute;
  visibility: hidden;
  width: 100%;
  opacity: 0;
}

.fade-leave-to {
  // overflow: hidden;
  visibility: hidden;
  position: absolute;
  width: 100%;
  opacity: 0;
}
</style>
